export const integrationControl = {
  productEntitlements: "Quyền sử dụng sản phẩm",
  entitlementHelp:
    "Chọn loại quyền và ghi nhận điều khoản theo hợp đồng. Hiệu lực hiện tại còn phụ thuộc thời hạn; việc lưu hợp đồng không tự mở nhà cung cấp.",

  rightsSections: "Các phần quyền sử dụng",
  releaseRights: "Mở dịch vụ",
  commercialRights: "Hợp đồng sử dụng",
  commercialIntro:
    "Quản lý quyền sử dụng và hợp đồng theo sản phẩm. Quyền mở nhà cung cấp được quản lý riêng ở mục Mở dịch vụ.",

  productSections: "Các phần cấu hình sản phẩm",
  productOverview: "Tổng quan",
  productMissing: "Không tìm thấy sản phẩm tích hợp.",
  connectionIssues: "Kết nối cần kiểm tra",
  connectionsLink: "Xem tất cả kết nối",
  noConnectionIssues:
    "Chưa ghi nhận kết nối cần kiểm tra. Đây không phải phép đo trực tiếp nhà cung cấp.",
  testNotPassed: "Phiên bản đang dùng chưa đạt kiểm thử hoặc chứng nhận",
  noActiveVersion: "Chưa có phiên bản đang phục vụ",
  disabledConnection: "Kết nối đã tắt",
  rollouts: "Mở khả năng theo ứng dụng",
  rolloutIntro:
    "Công tắc mặc định tắt. Bật công tắc chỉ cho phép xét readiness; chưa đủ để mở tính năng khi thiếu cấu hình, quyền, kiểm thử hoặc ACK.",
  capability: "Khả năng",
  revision: "Revision",

  accounts: "Tài khoản nền tảng",
  connections: "Kết nối",
  bindings: "Gán cho ứng dụng",
  routing: "Tuyến gửi email",
  rights: "Quyền sử dụng & thương mại",
  health: "Tình trạng tích hợp",
  product: "Sản phẩm",
  provider: "Nhà cung cấp",
  capabilities: "Khả năng adapter hỗ trợ",
  capabilitiesIntro: "Khả năng được adapter hỗ trợ không đồng nghĩa tính năng hiện dùng được.",
  noCapabilities: "Chưa khai khả năng trong danh mục.",
  empty: "Chưa có dữ liệu.",
  loading: "Đang tải…",
  reload: "Tải lại",
  open: "Mở cấu hình",
  account: "Tài khoản",
  connection: "Kết nối",
  activeVersion: "Phiên bản đang sử dụng",
  candidate: "Bản ứng viên mới nhất",
  state: "Trạng thái",
  app: "Ứng dụng",
  environment: "Môi trường",
  enabled: "Bật",
  disabled: "Tắt",
  drainingInfo: "Không nhận outbound mới",
  deadline: "Hạn ân hạn (giờ Việt Nam)",
  platform: "Nền tảng",
  lab: "Phòng thử",
  entitlement: "Loại quyền",
  storedStatus: "Trạng thái theo hợp đồng",
  effectiveStatus: "Hiệu lực hiện tại",
  contractRef: "Số hợp đồng",
  effectiveFrom: "Hiệu lực từ (giờ Việt Nam)",
  expiresAt: "Hết hạn (giờ Việt Nam)",
  note: "Ghi chú",
  save: "Lưu quyền",
  saved: "Đã lưu; kiểm tra kết quả đồng bộ phía dưới.",
  pending: "Chưa xác minh",
  negotiating: "Đang đàm phán",
  active: "Đang hiệu lực",
  suspended: "Tạm ngừng",
  expired: "Đã hết hạn",
  routeIntro: "Điều hướng email theo ứng dụng: tuyến chính, dự phòng và cổng kiểm.",
  healthIntro:
    "Tín hiệu đang mở của tuyến email và trạng thái kiểm thử kết nối; chưa có tín hiệu không phải bằng chứng nhà cung cấp đang hoạt động.",
  noSignals: "Không có tín hiệu đang mở",
  connectionStatus: "Trạng thái kết nối",
  sync: "Kết quả đồng bộ",
  back: "Nhà cung cấp",
  apps: "Ứng dụng sử dụng",
  resell: "Bán lại",
  internal_use: "Dùng nội bộ",
  production_api: "API production",
  white_label: "Nhãn riêng",
  bulk_api: "API số lượng lớn",
} as const;
